import './css/About.css';

const About = () => {
    return (
        <section className="about-author">
            <img className="selfie" src="/selfie.JPG" width="200px" height="200px" />
            <div>
                <h2>About Justin</h2>
                <p>Justin was born in Los Angeles and went to school in Santa Barbara and San Francisco. With more than a decade of experience in web development he now works out of Calaveras county after moving there to escape the pandemic.</p>
                <p>When not working on projects he enjoys photography, planting trees, scuba diving and bicycling.</p>
            </div>
        </section>
    );
}

export default About;